import React, { useState, useEffect } from 'react';
import {
  TextField,
  Typography,
  Alert,
  CircularProgress,
  Snackbar,
  Modal,
  Paper,
  Button,
  Switch,
  FormControlLabel, Checkbox, Tabs, Tab, Box,
} from '@mui/material';
import Popper from '@mui/material/Popper';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from 'xlsx';
import Autocomplete from '@mui/material/Autocomplete';
import { ArrowLeft, Pencil, Settings, X, Minus, Plus, FileText, FileSpreadsheet } from 'lucide-react';

function InventoryCount() {
  const { sessionId } = useParams();
  const [session, setSession] = useState(null);
  const [products, setProducts] = useState([]);
  const [scannedBarcode, setScannedBarcode] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [successMessage, setSuccessMessage] = useState('');
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [isLoadingProducts, setIsLoadingProducts] = useState(true);
  const [openModal, setOpenModal] = useState(false);
  const [openSettingsModal, setOpenSettingsModal] = useState(false);
  const [newSessionName, setNewSessionName] = useState('');
  const [audioEnabled, setAudioEnabled] = useState(true);
  const [audioAlertVisible, setAudioAlertVisible] = useState(true);
  const [audioDisabledAlertVisible, setAudioDisabledAlertVisible] = useState(false);
  const navigate = useNavigate();
  const [incrementValue, setIncrementValue] = useState(1);
  const [scanMode, setScanMode] = useState('increment');
  const [checkedProducts, setCheckedProducts] = useState([]);
  const [finishStatus, setFinishStatus] = useState(false);
  const [openAddBarcodeModal, setOpenAddBarcodeModal] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [allProducts, setAllProducts] = useState([]);
  const [allProducts1, setAllProducts1] = useState([]);
  const [quantity, setQuantity] = useState(1);
  const [tabValue, setTabValue] = useState(0);
  const [openValidationModal, setOpenValidationModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [submittedProducts, setSubmittedProducts] = useState([]);
  const [isContinueEnabled, setIsContinueEnabled] = useState(false);
  const [submittedStatus, setSubmittedStatus] = useState(false);

  const handleOpenAddBarcodeModal = () => {
    setOpenAddBarcodeModal(true);
  };

  useEffect(() => {
    const storedAudioSetting = localStorage.getItem('audioEnabled');
    if (storedAudioSetting !== null) {
      setAudioEnabled(JSON.parse(storedAudioSetting));
    }

    if (!sessionId) return;

    const fetchSessionData = async () => {
      try {
        console.log('Fetching session data...');
        const sessionResponse = await axios.get(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory-counts/${sessionId}`);

        console.log('Session data fetched:', sessionResponse.data);
        setSession(sessionResponse.data);
        if (sessionResponse.data.status === 'submitted') {
          setSubmittedStatus(true);
          setFinishStatus(true);
        } else if (sessionResponse.data.status === 'finished') {
          setFinishStatus(true);
          setSubmittedStatus(false);
        } else {
          setFinishStatus(false);
          setSubmittedStatus(false);
        }
        setNewSessionName(sessionResponse.data.sessionName);
      } catch (error) {
        console.error('Error fetching session data:', error);
        setError('Failed to load session data.');
        setOpenSnackbar(true);
      } finally {
        setLoading(false);
      }
    };

    const fetchBarcodes = async () => {
      try {
        const response = await axios.get('https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/products/barcodes');
        setProducts(response.data);
      } catch (error) {
        console.error('Error fetching products:', error);
      }
    };

    const fetchAllProducts = async () => {
      try {
        const response = await axios.get('https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/products-for-inventorycount');
        setAllProducts(response.data);
        console.log('Products for inventory count:', response.data);

        const response1 = await axios.get('https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/products');
        setAllProducts1(response1.data);
        console.log('All products:', response1.data);

        setIsLoadingProducts(false);
      } catch (error) {
        console.error('Error fetching all products:', error);
      }
    };

    fetchAllProducts();
    fetchBarcodes();
    fetchSessionData();
  }, [sessionId]);

  const playSound = (frequency) => {
    if (!audioEnabled) {
      setAudioDisabledAlertVisible(true);
      return;
    }
    const audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.type = 'square';
    oscillator.frequency.setValueAtTime(frequency, audioCtx.currentTime);
    gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime);

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    oscillator.start();
    oscillator.stop(audioCtx.currentTime + 0.5);
  };

  const playSuccessSound = () => playSound(660);
  const playErrorSound = () => playSound(220);

  const handleScan = async () => {
    setError('');
    setSuccessMessage('');

    try {
      console.log(`Checking case for scanned barcode: ${scannedBarcode}`);
      const caseResponse = await axios.get(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory-counts/case/${scannedBarcode}`);
      const caseItem = caseResponse.data;

      if (caseItem) {
        console.log('Received case item from backend:', JSON.stringify(caseItem, null, 2));

        const productTitle = caseItem.productId.title;
        const productBarcode = caseItem.caseBarcode;

        let adjustmentMultiplier = incrementValue;
        if (scanMode === 'decrement') {
          adjustmentMultiplier = -adjustmentMultiplier;
        }

        const adjustment = Number(caseItem.quantity) * adjustmentMultiplier;

        const existingItemIndex = session?.items.findIndex(item => item.title === productTitle);

        if (existingItemIndex !== -1) {
          const updatedItems = [...session.items];
          const currentCount = Number(updatedItems[existingItemIndex].countedInventory) || 0;
          updatedItems[existingItemIndex].countedInventory = currentCount + adjustment;
          setSession(prev => ({ ...prev, items: updatedItems }));
        } else {
          const currentInventory = Number(caseItem.productId.inventoryLevels?.[0]?.quantity) || 0;
          const newItem = {
            barcode: productBarcode,
            title: productTitle,
            currentInventory,
            countedInventory: adjustment,
          };
          setSession(prev => ({ ...prev, items: [...prev.items, newItem] }));
        }

        await axios.put(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory-counts/${session._id}/add-item`, {
          item: {
            barcode: productBarcode,
            title: productTitle,
            currentInventory: Number(caseItem.productId.inventoryLevels?.[0]?.quantity) || 0,
          },
          adjustment,
        });

        setSuccessMessage(`Scanned case: ${caseItem.caseBarcode}, product: ${productTitle} (x${adjustment})`);
        setOpenSnackbar(true);
        playSuccessSound();

        setScannedBarcode('');
        return;
      }
    } catch (error) {
      console.error('Error checking case barcode:', error.message);
    }

    const matchedProduct = products.find(p => p.barcode === scannedBarcode);
    if (!matchedProduct) {
      setError(
        <>
          Product not found for the scanned barcode.{' '}
          <Button variant="text" color="primary" onClick={handleOpenAddBarcodeModal} sx={{ textTransform: 'none' }}>
            Add New Barcode
          </Button>
        </>
      );
      setOpenSnackbar(true);
      playErrorSound();
      return;
    }

    const existingItemIndex = session?.items.findIndex(item => item.title === matchedProduct.title);

    let adjustmentMultiplier = incrementValue;
    if (scanMode === 'decrement') {
      adjustmentMultiplier = -adjustmentMultiplier;
    }

    if (existingItemIndex !== -1) {
      const updatedItems = [...session.items];
      updatedItems[existingItemIndex].countedInventory += adjustmentMultiplier;
      setSession(prev => ({ ...prev, items: updatedItems }));
    } else {
      const newItem = {
        barcode: scannedBarcode,
        title: matchedProduct.title,
        currentInventory: matchedProduct.currentInventory,
        countedInventory: adjustmentMultiplier,
      };
      setSession(prev => ({ ...prev, items: [...prev.items, newItem] }));
    }

    setSuccessMessage(`Scanned: ${matchedProduct.title}`);
    setOpenSnackbar(true);
    playSuccessSound();

    try {
      await axios.put(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory-counts/${session._id}/add-item`, {
        item: {
          barcode: scannedBarcode,
          title: matchedProduct.title,
          currentInventory: matchedProduct.currentInventory,
        },
        adjustment: adjustmentMultiplier,
      });
    } catch (error) {
      console.error('Error adding item to session:', error);
      setError('Failed to add scanned item.');
      setOpenSnackbar(true);
      playErrorSound();
    }

    setScannedBarcode('');
    setIncrementValue(1);
    setScanMode('increment');
  };

  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handleOpenSettingsModal = () => setOpenSettingsModal(true);
  const handleCloseSettingsModal = () => {
    setOpenSettingsModal(false);
    setAudioDisabledAlertVisible(false);
  };

  const toggleAudioEnabled = () => {
    setAudioEnabled(prev => {
      const newAudioEnabled = !prev;
      localStorage.setItem('audioEnabled', JSON.stringify(newAudioEnabled));
      return newAudioEnabled;
    });
  };

  const saveSessionName = async () => {
    try {
      setLoading(true);
      const updatedSession = { sessionName: newSessionName };
      const response = await axios.put(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory-counts/${session._id}/name`, updatedSession);
      setSession(response.data);
      setOpenModal(false);
    } catch (error) {
      console.error('Error updating session name:', error.response ? error.response.data : error.message);
      setError('Failed to update session name.');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleFinishSession = async () => {
    try {
      setLoading(true);
      await axios.put(`https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory-counts/${session._id}/finish`);
      setFinishStatus(true);
      setSuccessMessage('Session finished.');
      setOpenSnackbar(true);
    } catch (error) {
      console.error('Error finishing session:', error);
      setError('Failed to finish session.');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleSelectProduct = (barcode) => {
    setCheckedProducts((prev) => {
      if (prev.includes(barcode)) {
        return prev.filter(id => id !== barcode);
      } else {
        return [...prev, barcode];
      }
    });
  };

  const handleSubmitSelectedProducts = async () => {
    try {
      console.log("Starting submission of selected products...");

      const selectedProductsPayload = session.items
        .filter(item => checkedProducts.includes(item.barcode))
        .map(product => ({
          title: product.title,
          previousInventory: product.currentInventory,
          newInventory: product.countedInventory,
        }));

      console.log("Selected Products Payload:", selectedProductsPayload);

      if (selectedProductsPayload.length === 0) {
        console.error('No products selected for submission.');
        return;
      }

      setSubmittedProducts(selectedProductsPayload);
      console.log("Opening validation modal...");
      setOpenValidationModal(true);
      setIsLoading(true);
      setIsContinueEnabled(false);

      setTimeout(() => {
        console.log("Ending loading animation, enabling continue button...");
        setIsLoading(false);
        setIsContinueEnabled(true);
      }, 5000);

      console.log("Sending request to backend to update selected products...");
      const response = await axios.put(
        `https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory-counts/${session._id}/submit-selected`,
        { selectedProducts: selectedProductsPayload }
      );
      console.log("Response from backend:", response.data);

      console.log('Selected products submitted successfully.');
      setCheckedProducts([]);
      console.log("Checked products cleared after submission.");

    } catch (error) {
      console.error('Error submitting selected products:', error);
    }
  };

  const handleContinue = () => {
    window.location.reload(true);
  };

  const handleExportPDF = () => {
    const doc = new jsPDF();
    doc.setFontSize(14);
    doc.text(`Inventory Count Report`, 14, 15);

    doc.setFontSize(11);
    doc.text(`Session Name: ${session.sessionName}`, 14, 25);
    doc.text(`Status: ${session.status || (submittedStatus ? 'submitted' : finishStatus ? 'finished' : 'in progress')}`, 14, 32);
    doc.text(`Submitted At: ${session.submittedAt ? new Date(session.submittedAt).toLocaleString() : '—'}`, 14, 39);

    const tableColumn = ["Product Name", "Counted", "Current", "Difference"];
    const tableRows = [];

    session.items.forEach(item => {
      const currentProduct = allProducts.find(
        p => p.barcode?.trim() === String(item.barcode).trim()
      ) || allProducts.find(
        p => p.title?.trim() === item.title?.trim()
      );
      const currentInventory = currentProduct ? currentProduct.currentInventory : 0;
      const diff = item.countedInventory - currentInventory;

      tableRows.push([
        item.title,
        item.countedInventory,
        currentInventory,
        diff
      ]);
    });

    doc.autoTable({
      startY: 45,
      head: [tableColumn],
      body: tableRows,
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: [22, 160, 133], textColor: 255, halign: 'center' },
      columnStyles: {
        0: { cellWidth: 70 },
        1: { cellWidth: 30, halign: 'right' },
        2: { cellWidth: 30, halign: 'right' },
        3: { cellWidth: 30, halign: 'right' },
      }
    });

    const filename = `Inventory_${session.sessionName || 'Session'}_${new Date().toISOString().slice(0, 10)}.pdf`;
    doc.save(filename);
  };

  const handleExportExcel = () => {
    const worksheetData = [
      ["Session Name", session.sessionName],
      ["Status", session.status || (submittedStatus ? 'submitted' : finishStatus ? 'finished' : 'in progress')],
      ["Submitted At", session.submittedAt ? new Date(session.submittedAt).toLocaleString() : '—'],
      [],
      ["Product Name", "Counted Inventory", "Current Inventory", "Difference"]
    ];

    session.items.forEach(item => {
      const currentProduct = allProducts.find(
        p => p.barcode?.trim() === String(item.barcode).trim()
      ) || allProducts.find(
        p => p.title?.trim() === item.title?.trim()
      );
      const currentInventory = currentProduct ? currentProduct.currentInventory : 0;
      const diff = item.countedInventory - currentInventory;

      worksheetData.push([
        item.title,
        item.countedInventory,
        currentInventory,
        diff
      ]);
    });

    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    const columnWidths = worksheetData[4].map((_, i) => ({
      wch: Math.max(
        ...worksheetData.map(row => String(row[i] || '').length + 2)
      )
    }));
    worksheet['!cols'] = columnWidths;

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Inventory Count');
    const filename = `Inventory_${session.sessionName || 'Session'}_${new Date().toISOString().slice(0, 10)}.xlsx`;
    XLSX.writeFile(workbook, filename);
  };

  const handleSubmitSession = async () => {
    try {
      setLoading(true);
      await axios.put(
        `https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory-counts/${session._id}/submit-session`
      );
      setSubmittedStatus(true);
      setSession(prev => ({
        ...prev,
        status: 'submitted',
        submittedAt: new Date().toISOString()
      }));
      setSuccessMessage('Session submitted.');
      setOpenSnackbar(true);
    } catch {
      setError('Failed to submit session.');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
    }
  };

  const handleAddBarcode = async () => {
    setSelectedProduct(null);
    if (!selectedProduct || !scannedBarcode) {
      setError('Please select a product and provide a barcode.');
      setOpenSnackbar(true);
      return;
    }

    if (tabValue !== 0 && (!quantity || quantity <= 0)) {
      setError('Please enter a valid quantity for the case.');
      setOpenSnackbar(true);
      return;
    }

    setLoading(true);

    try {
      if (tabValue === 0) {
        const response = await axios.put(
          `https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/inventory-counts/products/${selectedProduct.id}/update-barcode`,
          { barcode: scannedBarcode }
        );
        console.log(response);
        setSuccessMessage('Barcode added for individual product successfully.');
      } else {
        console.log('hello', scannedBarcode, selectedProduct._id, quantity);
        await axios.post('https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/cases', {
          caseBarcode: scannedBarcode,
          productId: selectedProduct._id,
          quantity,
        });
        setSuccessMessage('Barcode added for case successfully.');
      }

      setOpenSnackbar(true);
    } catch (err) {
      setError('Error updating the product with the new barcode.');
      setOpenSnackbar(true);
    } finally {
      setLoading(false);
      setOpenAddBarcodeModal(false);
      setError('');
      const response = await axios.get('https://shopify-inv-tracker-backend-d0b1c1125141.herokuapp.com/api/products/barcodes');
      setProducts(response.data);
      setScannedBarcode('');
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      const eligibleBarcodes = session.items
        .filter(item => {
          const currentProduct = allProducts.find(
            p => p.barcode?.trim() === String(item.barcode).trim()
          ) || allProducts.find(
            p => p.title?.trim() === item.title?.trim()
          );
          const currentInventory = currentProduct ? currentProduct.currentInventory : 0;
          const diff = item.countedInventory - currentInventory;
          return diff !== 0;
        })
        .map(item => item.barcode ? String(item.barcode).trim() : "");

      setCheckedProducts(eligibleBarcodes);
    } else {
      setCheckedProducts([]);
    }
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress size={28} thickness={3} />
      </Box>
    );
  }

  if (isLoadingProducts) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 6 }}>
        <CircularProgress size={28} thickness={3} />
      </Box>
    );
  }

  return (
    <Box className="fade-in">

      {/* Add Barcode Modal */}
      <Modal open={openAddBarcodeModal} onClose={() => setOpenAddBarcodeModal(false)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Paper sx={{ p: 4, width: { xs: '90%', sm: 500 }, borderRadius: 3, position: 'relative' }}>
          <Button
            onClick={() => setOpenAddBarcodeModal(false)}
            sx={{ position: 'absolute', top: 16, right: 16, minWidth: 32, p: 0.5, color: 'text.secondary' }}
          >
            <X size={18} />
          </Button>

          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2, textAlign: 'center' }}>
            Add {tabValue === 0 ? 'Product' : 'Case'} Barcode
          </Typography>

          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            variant="fullWidth"
            sx={{
              mb: 3,
              '& .MuiTabs-indicator': { backgroundColor: '#2383e2' },
              '& .MuiTab-root': { textTransform: 'none', fontWeight: 500 },
            }}
          >
            <Tab label="Individual Product" />
            <Tab label="Case" />
          </Tabs>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
            <TextField
              label="Scanned Barcode"
              variant="outlined"
              fullWidth
              size="small"
              value={scannedBarcode || ''}
              onChange={(e) => setScannedBarcode(e.target.value)}
            />

            {tabValue === 0 ? (
              <Autocomplete
                options={allProducts}
                getOptionLabel={(option) =>
                  option.title ? option.title.replace(' - Default Title', '') : 'Unnamed Product'
                }
                value={selectedProduct || null}
                onChange={(event, newValue) => setSelectedProduct(newValue)}
                renderInput={(params) => (
                  <TextField {...params} label="Select Product" variant="outlined" fullWidth size="small" />
                )}
                PopperComponent={(props) => (
                  <Popper {...props} placement="bottom-start" style={{ width: '100%' }} />
                )}
              />
            ) : (
              <>
                <Autocomplete
                  options={allProducts1}
                  getOptionLabel={(option) =>
                    option.title ? option.title.replace(' - Default Title', '') : 'Unnamed Product'
                  }
                  value={selectedProduct || null}
                  onChange={(event, newValue) => setSelectedProduct(newValue)}
                  renderInput={(params) => (
                    <TextField {...params} label="Select Product" variant="outlined" fullWidth size="small" />
                  )}
                  PopperComponent={(props) => (
                    <Popper {...props} placement="bottom-start" style={{ width: '100%' }} />
                  )}
                />
                <TextField
                  label="Quantity in Case"
                  type="number"
                  fullWidth
                  size="small"
                  value={null}
                  onChange={(e) => setQuantity(Number(e.target.value))}
                />
              </>
            )}

            <Button
              variant="contained"
              onClick={handleAddBarcode}
              disabled={loading}
              sx={{ bgcolor: '#2383e2', '&:hover': { bgcolor: '#1b6ec2' }, py: 1.25 }}
            >
              {loading ? 'Saving...' : 'Save'}
            </Button>
          </Box>
        </Paper>
      </Modal>

      {/* Audio Alerts */}
      {audioAlertVisible && (
        <Alert severity="info" sx={{ mb: 2, borderRadius: 2 }} onClose={() => setAudioAlertVisible(false)}>
          Audio feedback is enabled for success and error actions. Adjust in settings.
        </Alert>
      )}

      {audioDisabledAlertVisible && (
        <Alert severity="warning" sx={{ mb: 2, borderRadius: 2 }} onClose={() => setAudioDisabledAlertVisible(false)}>
          Audio feedback is currently disabled. Enable it in settings.
        </Alert>
      )}

      {/* Header */}
      <Button
        onClick={() => navigate(-1)}
        startIcon={<ArrowLeft size={16} />}
        sx={{ mb: 2, color: 'text.secondary', fontWeight: 500 }}
      >
        Back
      </Button>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
        <Typography variant="h4" sx={{ fontWeight: 700, letterSpacing: '-0.02em' }}>
          {session ? session.sessionName : 'Unnamed Session'}
        </Typography>
        <Button onClick={handleOpenModal} sx={{ minWidth: 32, p: 0.5, color: 'text.secondary' }}>
          <Pencil size={16} />
        </Button>
        <Button onClick={handleOpenSettingsModal} sx={{ minWidth: 32, p: 0.5, color: 'text.secondary' }}>
          <Settings size={16} />
        </Button>
      </Box>

      {/* Status */}
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
        <Box sx={{
          px: 1.5, py: 0.25, borderRadius: 1,
          bgcolor: submittedStatus ? 'rgba(35,131,226,0.08)' : finishStatus ? 'rgba(16,185,129,0.08)' : 'rgba(245,158,11,0.08)',
          border: '1px solid',
          borderColor: submittedStatus ? 'rgba(35,131,226,0.2)' : finishStatus ? 'rgba(16,185,129,0.2)' : 'rgba(245,158,11,0.2)',
        }}>
          <Typography variant="caption" sx={{
            fontWeight: 600,
            color: submittedStatus ? '#2383e2' : finishStatus ? '#10b981' : '#f59e0b',
          }}>
            {submittedStatus ? 'Submitted' : finishStatus ? 'Finished' : 'In Progress'}
          </Typography>
        </Box>
        {submittedStatus && session.submittedAt && (
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Submitted: {new Date(session.submittedAt).toLocaleString()}
          </Typography>
        )}
      </Box>

      {error && (
        <Box sx={{ p: 2, mb: 2, borderRadius: 2, bgcolor: 'rgba(239,68,68,0.08)', border: '1px solid rgba(239,68,68,0.2)' }}>
          <Typography variant="body2" color="error">{error}</Typography>
        </Box>
      )}
      {successMessage && (
        <Box sx={{ p: 2, mb: 2, borderRadius: 2, bgcolor: 'rgba(16,185,129,0.08)', border: '1px solid rgba(16,185,129,0.2)' }}>
          <Typography variant="body2" sx={{ color: '#059669' }}>{successMessage}</Typography>
        </Box>
      )}

      {/* Scanner Controls */}
      {(!finishStatus && !submittedStatus) && (
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 3, flexWrap: 'wrap' }}>
          <TextField
            label="Scan Barcode"
            variant="outlined"
            size="small"
            value={scannedBarcode}
            onChange={e => setScannedBarcode(e.target.value)}
            onKeyPress={e => e.key === 'Enter' && handleScan()}
            sx={{ flex: 1, minWidth: 200 }}
          />

          <Button
            onClick={() => setScanMode('decrement')}
            variant={scanMode === 'decrement' ? 'contained' : 'outlined'}
            color="error"
            sx={{ minWidth: 40, p: 1 }}
          >
            <Minus size={18} />
          </Button>

          <TextField
            type="number"
            value={incrementValue}
            onChange={(e) => setIncrementValue(Number(e.target.value))}
            inputProps={{ min: 1 }}
            size="small"
            sx={{ width: 80, '& .MuiInputBase-input': { textAlign: 'center' } }}
          />

          <Button
            onClick={() => setScanMode('increment')}
            variant={scanMode === 'increment' ? 'contained' : 'outlined'}
            sx={{
              minWidth: 40, p: 1,
              ...(scanMode === 'increment' ? { bgcolor: '#2383e2', '&:hover': { bgcolor: '#1b6ec2' } } : {}),
            }}
          >
            <Plus size={18} />
          </Button>
        </Box>
      )}

      {/* Products Table */}
      <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', mb: 3 }}>
        <Box sx={{
          display: 'grid',
          gridTemplateColumns: finishStatus && !submittedStatus
            ? '50px 2fr 1fr'
            : !finishStatus
              ? '2fr 1fr 1fr 1fr'
              : '2fr 1fr',
          px: 2.5, py: 1.5,
          borderBottom: '1px solid', borderColor: 'divider',
          bgcolor: 'action.hover',
        }}>
          {finishStatus && !submittedStatus && (
            <Box>
              <Typography variant="caption" sx={{ fontWeight: 600, fontSize: '0.65rem', color: 'text.secondary', display: 'block' }}>
                Select
              </Typography>
              <Checkbox
                size="small"
                onChange={handleSelectAll}
                checked={
                  session?.items?.length > 0 &&
                  session.items
                    .filter(item => {
                      const currentProduct = allProducts.find(
                        p => p.barcode?.trim() === String(item.barcode).trim()
                      ) || allProducts.find(
                        p => p.title?.trim() === item.title?.trim()
                      );
                      const currentInventory = currentProduct ? currentProduct.currentInventory : 0;
                      const diff = item.countedInventory - currentInventory;
                      return diff !== 0;
                    })
                    .every(item => checkedProducts.includes(String(item.barcode).trim()))
                }
                sx={{ p: 0, '&.Mui-checked': { color: '#2383e2' } }}
              />
            </Box>
          )}
          <Typography variant="caption" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', fontSize: '0.65rem', color: 'text.secondary' }}>
            Product Name
          </Typography>
          <Typography variant="caption" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', fontSize: '0.65rem', color: 'text.secondary' }}>
            Counted
          </Typography>
          {!finishStatus && (
            <>
              <Typography variant="caption" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', fontSize: '0.65rem', color: 'text.secondary' }}>
                Current
              </Typography>
              <Typography variant="caption" sx={{ fontWeight: 600, textTransform: 'uppercase', letterSpacing: '0.04em', fontSize: '0.65rem', color: 'text.secondary' }}>
                Difference
              </Typography>
            </>
          )}
        </Box>

        {session?.items?.map((item, index) => {
          const itemBarcode = item.barcode ? String(item.barcode).trim() : "";
          const itemTitleSub = item.title ? item.title.trim().substring(0, 6) : "";

          let currentProduct = allProducts.find((p) => {
            const productBarcode = p.barcode ? String(p.barcode).trim() : "";
            return productBarcode === itemBarcode;
          });

          if (currentProduct) {
            console.log(`✅ Matched item ${index + 1} by barcode:`, { item, matchedProduct: currentProduct });
          }

          if (!currentProduct && itemTitleSub) {
            currentProduct = allProducts.find((p) => {
              const productTitleSub = p.title ? p.title.trim().substring(0, 6) : "";
              return productTitleSub === itemTitleSub;
            });

            if (currentProduct) {
              console.log(`✅ Matched item ${index + 1} by title substring:`, { item, matchedProduct: currentProduct });
            }
          }

          if (!currentProduct) {
            console.warn(`❌ No match found for item ${index + 1}:`, item);
          }

          const currentInventory = currentProduct?.currentInventory || 0;
          const inventoryDifference = item.countedInventory - currentInventory;

          console.log(currentProduct);

          return (
            <Box
              key={index}
              sx={{
                display: 'grid',
                gridTemplateColumns: finishStatus && !submittedStatus
                  ? '50px 2fr 1fr'
                  : !finishStatus
                    ? '2fr 1fr 1fr 1fr'
                    : '2fr 1fr',
                px: 2.5, py: 1.5,
                borderBottom: '1px solid', borderColor: 'divider',
                alignItems: 'center',
                bgcolor: !finishStatus && inventoryDifference === 0 ? 'rgba(16,185,129,0.04)' : 'inherit',
                '&:hover': { bgcolor: 'action.hover' },
              }}
            >
              {finishStatus && !submittedStatus && (
                <Checkbox
                  size="small"
                  checked={checkedProducts.includes(itemBarcode)}
                  onChange={() => handleSelectProduct(itemBarcode)}
                  disabled={inventoryDifference === 0}
                  sx={{ p: 0, '&.Mui-checked': { color: '#2383e2' } }}
                />
              )}
              <Typography variant="body2" sx={{ fontWeight: 500 }}>{item.title}</Typography>
              <Typography variant="body2">{item.countedInventory}</Typography>
              {!finishStatus && (
                <>
                  <Typography variant="body2">{currentInventory}</Typography>
                  <Typography variant="body2" sx={{
                    fontWeight: 600,
                    color: inventoryDifference > 0 ? '#10b981' : inventoryDifference < 0 ? '#ef4444' : 'text.secondary',
                  }}>
                    {inventoryDifference > 0 ? '+' : ''}{inventoryDifference}
                  </Typography>
                </>
              )}
            </Box>
          );
        })}
      </Box>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        message={error || successMessage}
      />

      {/* Edit Session Name Modal */}
      <Modal open={openModal} onClose={handleCloseModal}>
        <Paper sx={{ p: 4, width: 400, margin: 'auto', mt: '20vh', borderRadius: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>Edit Session Name</Typography>
          <TextField
            label="Session Name"
            variant="outlined"
            fullWidth
            size="small"
            sx={{ mb: 2 }}
            value={newSessionName}
            onChange={(e) => setNewSessionName(e.target.value)}
          />
          <Button
            variant="contained"
            fullWidth
            onClick={saveSessionName}
            sx={{ bgcolor: '#2383e2', '&:hover': { bgcolor: '#1b6ec2' }, py: 1.25 }}
          >
            Save
          </Button>
        </Paper>
      </Modal>

      {/* Audio Settings Modal */}
      <Modal open={openSettingsModal} onClose={handleCloseSettingsModal}>
        <Paper sx={{ p: 4, width: 400, margin: 'auto', mt: '20vh', borderRadius: 3, position: 'relative' }}>
          <Button
            onClick={handleCloseSettingsModal}
            sx={{ position: 'absolute', top: 16, right: 16, minWidth: 32, p: 0.5, color: 'text.secondary' }}
          >
            <X size={18} />
          </Button>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>Audio Settings</Typography>
          <FormControlLabel
            control={<Switch checked={audioEnabled} onChange={toggleAudioEnabled} />}
            label="Enable Audio Feedback"
            sx={{ mb: 2 }}
          />
          <Box sx={{ display: 'flex', gap: 1, mb: 2 }}>
            <Button
              variant="contained"
              size="small"
              onClick={playSuccessSound}
              sx={{ bgcolor: '#10b981', '&:hover': { bgcolor: '#059669' } }}
            >
              Test Success
            </Button>
            <Button variant="contained" size="small" color="error" onClick={playErrorSound}>
              Test Error
            </Button>
          </Box>
          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
            Enable or disable sound feedback for success and error actions.
          </Typography>
        </Paper>
      </Modal>

      {/* Validation Modal */}
      <Modal open={openValidationModal} onClose={() => setOpenValidationModal(false)}>
        <Paper sx={{ p: 4, width: '80%', margin: 'auto', mt: '10vh', maxHeight: '80vh', overflowY: 'auto', borderRadius: 3 }}>
          <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
            {isLoading ? 'Processing...' : 'Submitted Products Summary'}
          </Typography>

          {isLoading ? (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
              <CircularProgress size={28} thickness={3} />
            </Box>
          ) : (
            <>
              <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2, overflow: 'hidden', maxHeight: '50vh', overflowY: 'auto' }}>
                <Box sx={{
                  display: 'grid', gridTemplateColumns: '2fr 1fr 1fr',
                  px: 2.5, py: 1.5,
                  borderBottom: '1px solid', borderColor: 'divider',
                  bgcolor: 'action.hover',
                }}>
                  {['Product Name', 'Previous', 'New'].map(h => (
                    <Typography key={h} variant="caption" sx={{
                      fontWeight: 600, textTransform: 'uppercase', fontSize: '0.65rem', color: 'text.secondary',
                    }}>{h}</Typography>
                  ))}
                </Box>
                {submittedProducts.map((product, index) => (
                  <Box key={index} sx={{
                    display: 'grid', gridTemplateColumns: '2fr 1fr 1fr',
                    px: 2.5, py: 1.5,
                    borderBottom: '1px solid', borderColor: 'divider',
                    '&:last-child': { borderBottom: 'none' },
                  }}>
                    <Typography variant="body2" sx={{ fontWeight: 500 }}>{product.title}</Typography>
                    <Typography variant="body2">{product.previousInventory}</Typography>
                    <Typography variant="body2">{product.newInventory}</Typography>
                  </Box>
                ))}
              </Box>
              <Button
                variant="contained"
                onClick={handleContinue}
                disabled={!isContinueEnabled}
                sx={{ mt: 3, bgcolor: '#2383e2', '&:hover': { bgcolor: '#1b6ec2' } }}
              >
                Continue
              </Button>
            </>
          )}
        </Paper>
      </Modal>

      {/* Export Buttons */}
      <Box sx={{ display: 'flex', gap: 1.5, mb: 2, flexWrap: 'wrap' }}>
        <Button
          variant="contained"
          startIcon={<FileText size={16} />}
          onClick={handleExportPDF}
          sx={{ bgcolor: '#6366f1', '&:hover': { bgcolor: '#4f46e5' } }}
        >
          Export PDF
        </Button>
        <Button
          variant="contained"
          startIcon={<FileSpreadsheet size={16} />}
          onClick={handleExportExcel}
          sx={{ bgcolor: '#10b981', '&:hover': { bgcolor: '#059669' } }}
        >
          Export Excel
        </Button>
      </Box>

      {/* Action Buttons */}
      {!finishStatus && (
        <Button
          variant="contained"
          onClick={handleFinishSession}
          sx={{ mb: 2, bgcolor: '#10b981', '&:hover': { bgcolor: '#059669' } }}
        >
          Finish Session
        </Button>
      )}

      {finishStatus && !submittedStatus && (
        <Box sx={{ display: 'flex', gap: 1.5 }}>
          <Button
            variant="contained"
            onClick={handleSubmitSelectedProducts}
            sx={{ bgcolor: '#2383e2', '&:hover': { bgcolor: '#1b6ec2' } }}
          >
            Submit Selected Products
          </Button>
          <Button
            variant="contained"
            onClick={handleSubmitSession}
            sx={{ bgcolor: '#f59e0b', '&:hover': { bgcolor: '#d97706' } }}
          >
            Submit Session
          </Button>
        </Box>
      )}
    </Box>
  );
}

export default InventoryCount;
